const baseUrl = "https://phonearena-api.herokuapp.com";
export default baseUrl;